import React from 'react';
import ExploreLayout from '../components/ExploreLayout';
import ExploreSuccess from '../components/ExploreSuccess';
import useExplore from '../hooks/useExplore';

export default function ExploreLaunchPage() {
  const { state } = useExplore();
  const company = state.companyName || 'your operation';

  return (
    <ExploreLayout
      stepId="launch"
      eyebrow="Launch Trial"
      title="Explore can create customers."
      subtitle="This is the future conversion moment: the visitor has experienced MatrixOS, imagined their own operation, and can launch a real trial without a sales call."
      nextLabel="Finish"
      hideFooter
    >
      <div className="explore-split">
        <div className="explore-console">
          <div className="explore-console-header">
            <span>Launch Sequence</span>
            <strong>{company}</strong>
          </div>
          <div className="explore-console-screen">
            <div className="explore-console-row"><span>Create organization</span><strong>Ready</strong></div>
            <div className="explore-console-row"><span>Create owner account</span><strong>Ready</strong></div>
            <div className="explore-console-row"><span>Clone standards</span><strong>Ready</strong></div>
            <div className="explore-console-row"><span>Enable trial</span><strong>Future Sprint</strong></div>
          </div>
        </div>
        <div>
          <ExploreSuccess
            title="E1 framework complete"
            description="The route, layout, progress system and session-based journey are ready. Next we can make each mission interactive."
          />
          <p className="explore-subtitle" style={{ fontSize: 17 }}>
            Later, this button becomes: Launch My Company. For now, it proves the end-to-end Explore journey.
          </p>
          <button type="button" className="explore-primary-btn" style={{ marginTop: 18 }}>
            Launch My Company — coming next
          </button>
        </div>
      </div>
    </ExploreLayout>
  );
}
